export default "__VITE_ASSET__DobbuRha__"